/* Devlopment */
// export const URL = 'http://localhost:5000';
// export const SOCKET_URL = 'http://localhost:5500'

/* Prodevtion */
export const SOCKET_URL = 'https://sync-along-socket.onrender.com'; //'https://sync-along-socket-conection.herokuapp.com';
export const URL = 'https://sync-along-server-http.onrender.com'; //'https://sync-along.herokuapp.com';

